<bic-popup (close)="dialogRef.close(false)" [hasBackdrop]="true" [title]="title" customClass="w-[750px]">
  <div bicPopupContent class="flex flex-col items-start gap-4 text-sm">
    <div>Das ausgewählte Abo <span class="font-medium">"{{ productName }}"</span> wird für das aktuelle Profil <span
      class="font-medium">"{{ selectedOrganisation }}"</span> gebucht.
    </div>
    <div>
      <span class="text-green font-medium">Bitte beachte:</span>
      <ul class="list-disc pl-5">
        <li><span class="font-medium">Persönliches Profil</span>: Gekaufte Guthaben stehen ausschließlich Ihnen zur
          Verfügung.
        </li>
        <li><span class="font-medium">Team-Nutzung</span>: Möchten Sie Guthaben mit Mitgliedern Ihres Teams oder Ihrer
          Organisation teilen? Dann wechseln Sie bitte vor dem Kauf in das entsprechende Organisationsprofil.
        </li>
      </ul>
    </div>
  </div>
  <div bicPopupButtonGroup class="flex flex-row justify-end gap-4">
    <bic-button buttonType="white" matDialogClose>
      Abbrechen
    </bic-button>
    <bic-button (onClick)="goBuy()" buttonType="primary">
      Zur Buchung
    </bic-button>
  </div>
</bic-popup>
